import React from 'react';
import { Music, Phone, Mail, MapPin, Facebook, Instagram, Youtube, Twitter } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/d8wqvckb_Anointing%20-%201.png" 
                alt="Divine Anointing Logo"
                className="w-12 h-12 object-contain"
              />
              <div>
                <h3 className="font-bold text-xl">Nadja Scott</h3>
                <p className="text-sm text-gray-400">Divine Anointing</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed">
              Inspiring hearts and transforming lives through the power of gospel music and worship. 
              Join us in spreading divine love through song.
            </p>
            
            {/* Social Media */}
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://instagram.com/iamnadjascottandda" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-6">Services</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors">Choir Performances</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Private Gospel Lessons</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Church Event Bookings</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Wedding Ceremonies</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Corporate Events</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Music Workshops</a></li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="font-bold text-lg mb-6">About</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors">Our Story</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Meet Nadja Scott</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Our Mission</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Testimonials</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Gallery</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Press & Media</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-6">Contact Info</h4>
            
            {/* Manager Information */}
            <div className="mb-6">
              <h5 className="font-medium text-white mb-3">Management</h5>
              <p className="text-sm text-gray-400 mb-2">Manager Joseph Johnson</p>
              <p className="text-sm text-gray-400">Elite Complex</p>
            </div>
            
            <div className="space-y-4 text-sm text-gray-400">
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-red-600" />
                <a href="tel:202-704-4758" className="hover:text-white transition-colors">
                  202-704-4758
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-red-600" />
                <a href="mailto:theelitecomplex@gmail.com" className="hover:text-white transition-colors">
                  theelitecomplex@gmail.com
                </a>
              </div>
            </div>

            {/* Booking Notice */}
            <div className="mt-6 bg-red-600/10 border border-red-600/20 rounded-lg p-4">
              <h5 className="font-medium text-white mb-2">Booking Inquiries</h5>
              <p className="text-xs text-gray-400">
                For all booking requests and performance inquiries, please contact Manager Joseph Johnson at Elite Complex.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <div className="mb-4 md:mb-0">
              <p>&copy; 2025 Divine Anointing. All rights reserved.</p>
            </div>
            <div className="flex space-x-6">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-white transition-colors">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};